import * as api from "../api";
import { GET_LIKES } from "../constants/actionTypes";

// Get likes for a post
export const getLikes = (postId) => async (dispatch) => {
    try {
        const { data } = await api.fetchLikes(postId);  // <-- use fetchLikes here
        dispatch({ type: GET_LIKES, payload: { postId, likes: data } });
    } catch (err) {
        console.error(err);
    }
};

export const addLike = (postId) => async (dispatch) => {
    try {
        await api.addLike(postId);
        dispatch(getLikes(postId)); // fetch updated likes
    } catch (err) {
        console.error("Add like error:", err.response?.data || err.message);
    }
};

export const deleteLike = (postId) => async (dispatch) => {
    try {
        await api.deleteLike(postId);
        dispatch(getLikes(postId)); // fetch updated likes
    } catch (err) {
        console.error("Delete like error:", err.response?.data || err.message);
    }
};